import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=9f66dd8c&scoped=true"
import script from "./SideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SideMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=9f66dd8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f66dd8c",
  null
  
)

export default component.exports